import  styles from "./ModalDevicesActivation.module.scss";
import { useState } from "react";
import useWindowSize from "hooks/useWindowSize";
import MainAppGenericModal from "components/MainApp/atoms/Modals/GenericModal";
import Checkbox from "components/Auth/atoms/forms/CheckboxCostum";
import deviceIcon from "assets/images/device-icon-blue.svg";
import closeIcon from "assets/images/close-icon.svg";
import backArrow from "assets/images/back-arrow.svg";
import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";

const ModalDeviceActivation = ({
  isOpen,
  setIsOpen,
  devicesOptions,
  openRoom,
  closeRoom,
  activeDevices
}) => {
  const { isMobile } = useWindowSize();
  const [deviceSelected, setDeviceSelected] = useState([]);

  const handleSelect = device => {
    if (deviceSelected.includes(device.id)) {
      setDeviceSelected(prev =>
        prev.filter(deviceId => deviceId !== device.id)
      );
    } else {
      setDeviceSelected(prev => [...prev, device.id]);
    }
  };

  const handleClose = () => {
    setIsOpen(false);
    setDeviceSelected(activeDevices);
  };

  const handleSubmit = () => {
    if (deviceSelected.length > 0) {
      openRoom(deviceSelected);
    } else {
      closeRoom();
    }

    setIsOpen(false);
  };

  const contentPopUp = (
    <section className={styles["modal_device_activation"]}>
      <img src={isMobile ? backArrow : closeIcon} onClick={handleClose} />
      <header>
        <img src={deviceIcon} />
        <div>
          <h4>{i18n.t("device.activation")}</h4>
          <p>
            {i18n.t("active.devices")} <span>{activeDevices.length}</span>
          </p>
        </div>
      </header>
      <ul>
        {devicesOptions.map(device => (
          <li key={device.id} onClick={() => handleSelect(device)}>
            <Checkbox checked={deviceSelected.includes(device.id)} />
            {device.value}
          </li>
        ))}
      </ul>
      <footer>
        <button onClick={handleClose}>{capitalize(i18n.t("cancel"))}</button>
        <button onClick={handleSubmit}>{capitalize(i18n.t("save"))}</button>
      </footer>
    </section>
  );

  return (
    <MainAppGenericModal
      open={isOpen}
      content={contentPopUp}
      handleClose={handleClose}
      classContainer={styles["modal_device_activation-container"]}
      classModalContainer={styles["modal_device_activation-modal-container"]}
    />
  );
};

export default ModalDeviceActivation;
